// Generated by BUCKLESCRIPT VERSION 2.2.0, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("bs-platform/lib/js/array.js");
var Curry = require("bs-platform/lib/js/curry.js");

var slugifyier = require("slugify")
;

var slugify = (
function (s) {
  return slugifyier(s, {
    replacement: "-",    // replace spaces with replacement
    remove: null,        // regex to remove characters
    lower: true          // result in lower case
  });
}
  );

function slugifySectionNumber(sectionNumber) {
  return $$Array.map((function (fragment) {
                  switch (fragment) {
                    case "ier" : 
                        return "i";
                    case "1er" : 
                    case "premier" : 
                        return "1";
                    default:
                      return fragment;
                  }
                }), Curry._1(slugify, sectionNumber).split("-")).join("-");
}

exports.slugify = slugify;
exports.slugifySectionNumber = slugifySectionNumber;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/slugify.re
// module id = 64
// module chunks = 0